import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { useAuth } from '../../../hooks/useAuth';
import { EcommerceChannels } from '../../../components/EcommerceChannels';
import { SalesChannel } from '../../../components/SalesChannel';

export const SettingChannel: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState<'integration' | 'api'>(
    'integration'
  );

  return (
    <div className="py-4 lg:py-8">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <button
            onClick={() => navigate(-1)}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-gray-700" />
          </button>
          <h1 className="text-2xl font-bold text-gray-900">Channel</h1>
        </div>
        <div className="flex items-center  text-gray-600">
          Connect and manage your sales channels for seamless order processing.
        </div>
      </div>

      {/* Card */}
      <div className="bg-card rounded-lg shadow-sm border mb-6">
        {/* Tabs */}
        <div className="border-b px-10 pt-6 border-gray-200">
          <nav className="-mb-px flex space-x-10">
            {[
              { id: 'integration', label: 'Integration' },
              { id: 'api', label: 'Open API' },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id as typeof activeTab)}
                className={`
                  whitespace-nowrap py-1 px-1 border-b-2 font-medium text-lg
                  ${
                    activeTab === tab.id
                      ? 'border-accent text-primary'
                      : 'border-transparent hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Content */}
        <div className="p-10 space-y-12">
          {activeTab === 'integration' && (
            <>
              <SalesChannel />
            </>
          )}

          {activeTab === 'api' && (
            <div className="text-gray-500">
              Open API configuration coming soon.
            </div>
          )}
        </div>
      </div>

      <EcommerceChannels />
    </div>
  );
};

export default SettingChannel;
